import React from 'react';
import { Alert, Icon } from '@storable/canaveral-components';
import styles from './styles.scss';

export const editSuccessMessage = (
  <Alert className={styles.alert} context="success">
    <Icon context="success" id="success" label="robots edit success banner" />
    <span>Additional robots.txt content saved successfully</span>
  </Alert>
);

const ROBOTS_EDIT_WARNING_TEXT = 'Warning! Editing the robots.txt file can negatively impact your website if not done correctly. For more information, see';

const robotsInfoLink = (
  <a href="https://developers.google.com/search/docs/advanced/robots/intro">
    the robots.txt documentation from Google
  </a>
);

export const editWarningMessage = (
  <Alert className={styles.alert} context="warning">
    <Icon context="warning" id="warning-triangle" label="robots edit warning banner" />
    <span>{ROBOTS_EDIT_WARNING_TEXT} {robotsInfoLink}.</span>
  </Alert>
);

export const generateEditFailureMessage = errors => (
  <Alert className={styles.alert} context="danger">
    <Icon context="danger" id="warning" label="robots edit failure banner" />
    <span>Failed to save additional robots.txt content</span>
    {errors.map(error => <span>{error.message}</span>)}
  </Alert>
);

const PRIMARY_DOMAIN_ALERT_TEXT = 'A primary domain has not been set. Until this is completed, your site will not be crawled, and your robots.txt file cannot be edited.';

export const primaryDomainMessage = (
  <Alert className={styles.alert} context="info">
    <Icon context="info" id="info" label="no primary domain info banner" />
    <span>{PRIMARY_DOMAIN_ALERT_TEXT}</span>
  </Alert>
);

export const unauthorizedMessage = (
  <Alert className={styles.alert} context="warning">
    <Icon context="danger" id="warning" label="robots edit unauthorized banner" />
    <span>You are not authorized to edit robots.txt content</span>
  </Alert>
);
